<p-panelmenu
  #sideMenu
  [model]="routes"
>
  <ng-template
    #item
    let-item
  >
    <a
      class="flex w-full cursor-pointer p-2"
      pRipple
      [routerLink]="getRouterLink(item)"
      (click)="onItemClick(item)"
    >
      @if (item.icon) {
        <nsp-icon
          class="mr-2"
          [name]="item.icon"
        />
      }
      @if (item.label === 'NavFleet') {
        <img
          class="mr-2"
          src="../../../assets/images/navFleetIcon-72x72.png"
          alt="navfleet logo"
          width="20px"
        />
      }
      <div class="flex w-full justify-between">
        <span class="ml-2 whitespace-nowrap">
          {{ item.label }}
        </span>
        @if (item.internalOnly) {
          <nsp-icon [name]="IconNames.Key" />
        }
        @if (item.items && !item.expanded) {
          <nsp-icon [name]="IconNames.ChevronRight" />
        }
        @if (item.items && item.expanded) {
          <nsp-icon [name]="IconNames.ChevronDown" />
        }
      </div>
    </a>
  </ng-template>
</p-panelmenu>

<p-dialog
  header="Out of Sequence Report"
  [modal]="true"
  [(visible)]="outOfSequenceDialogVisible"
  [style]="{ width: '25rem' }"
>
  <p>
    This report type is out of the expected sequence. Do you want to continue?
  </p>
  <div class="mt-3 flex justify-end gap-2">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="dismissOutOfSequenceDialog()"
    />
    <p-button
      label="Confirm"
      (onClick)="confirmOutOfSequence()"
    />
  </div>
</p-dialog>
